/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type coberturaEnum = 0 | 1 ;

export const coberturaEnum = {

    NUMBER_0: 0 as coberturaEnum,

    NUMBER_1: 1 as coberturaEnum,
};

